<template>
  <v-app  class="grey lighten-4">
  <Navbar />

    <v-main>
      <SpeedDial/>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import Navbar from './components/Navbar'
import SpeedDial from './components/SpeedDial'

export default {
  components: { Navbar, SpeedDial },
  name: 'App',
  data: () => ({
    //
  }),


};
</script>
